import {
  selectGlobalLoading,
  selectToast,
  selectHasUserAcceptedTnC,
  selectTnCForCidpUser,
  selectGlobalFeatureFlags,
} from "scenes/selectors";
import { createSelector, createStructuredSelector } from "reselect";
import { initialState, State as DashboardSecuritySettingsState } from "./redux";
/**
 * Direct selector to the dashboardSecuritySettings state domain
 */

const selectDashboardSecuritySettingsDomain: (
  any
) => DashboardSecuritySettingsState = (state) =>
  state.dashboardSecuritySettings || initialState;

/**
 * Custom selectors to the dashboardSecuritySettings state
 */
export const selectDashboardSecuritySettings = createSelector(
  selectDashboardSecuritySettingsDomain,
  (substate) => substate
);

export const selectAuthenticators = createSelector(
  selectDashboardSecuritySettingsDomain,
  (substate) => substate.authenticators
);

export const selectLoading = createSelector(
  selectDashboardSecuritySettingsDomain,
  (substate) => substate.loading
);

export const selectPasskeys = createSelector(
  selectDashboardSecuritySettingsDomain,
  (substate) => substate.passkeys
);

/**
 * Multi instance selectors exporting a factory
 */
export const makeSelectDashboardSecuritySettings = () =>
  createSelector(selectDashboardSecuritySettingsDomain, (substate) => substate);

// add structured selectors here, which will be mapped as prop to scene component
export default createStructuredSelector({
  loading: selectLoading,
  authenticators: selectAuthenticators,
  toast: selectToast,
  globalLoading: selectGlobalLoading,
  updatedTnC: selectTnCForCidpUser,
  hasUpdatedTnCAccepted: selectHasUserAcceptedTnC,
  tncForCidpUser: selectTnCForCidpUser,
  passkeys: selectPasskeys,
  featureFlags: selectGlobalFeatureFlags,
});
